module.exports = __webpack_public_path__ + "static/paper_bird-d2298483704aa01c34a377e9ff7640df.png";